/** Phone layout (portrait or landscape): the same breakpoints as the phone rules in styles.css. */
import { useSyncExternalStore } from 'react';

const useQuery = (query: string) =>
  useSyncExternalStore(
    (onChange) => {
      const mq = window.matchMedia(query);
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
  );

export const usePhone = () => useQuery('(max-width: 800px), (max-height: 500px)');

/** Portrait phone: seats go three to a row (landscape keeps them all in one). */
export const usePortraitPhone = () => useQuery('(max-width: 800px) and (min-height: 501px)');
